import { branch, compose, renderComponent } from 'recompose';

import headerDropdownOld from './headerDropdownOld';
import headerDropdownNew from './headerDropdownNew';
import { flagNames, withInjectFeatureFlagsToProps } from '../../../../modules/infra/feature-flags';

export default compose(
  withInjectFeatureFlagsToProps([flagNames.AUTOPAYOUT_SELF_SERVE]),
  branch(
    props => props[flagNames.AUTOPAYOUT_SELF_SERVE],
    renderComponent(headerDropdownNew),
    renderComponent(headerDropdownOld),
  )
)();

